var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCollegeSearchWelcomeModalImage1 = function SvgCollegeSearchWelcomeModalImage1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 437 145"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "college-search-welcome-modal-image-1_svg__a",
    d: "M0 .29v26.872h8.969V.29z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "college-search-welcome-modal-image-1_svg__c",
    d: "M0 .29v26.872h69.255V.29z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "college-search-welcome-modal-image-1_svg__e",
    d: "M9.491 7.215V.29H.492v6.924h9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "college-search-welcome-modal-image-1_svg__g",
    d: "M0 49.058h69.357V.45H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "college-search-welcome-modal-image-1_svg__k",
    d: "M0 62.053h129.859V0H0z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "college-search-welcome-modal-image-1_svg__i",
    width: "116.7%",
    height: "117.1%",
    x: "-8.3%",
    y: "-7.6%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowBlurOuter1",
    values: "0 0 0 0 0.57254902 0 0 0 0 0.623529412 0 0 0 0 0.666666667 0 0 0 0.4 0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "college-search-welcome-modal-image-1_svg__j",
    width: 227.953,
    height: 222.388,
    x: 0.53,
    y: 0.306,
    rx: 12
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 25.929)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 195.388,
    height: 190.618,
    x: 0.454,
    y: 0.262,
    fill: "#FFF",
    rx: 12
  }), /*#__PURE__*/React.createElement("rect", {
    width: 144.027,
    height: 7.602,
    x: 26.493,
    y: 95.175,
    fill: "#DBE4EB",
    rx: 3.801
  }), /*#__PURE__*/React.createElement("rect", {
    width: 89.873,
    height: 7.602,
    x: 26.493,
    y: 111.037,
    fill: "#DBE4EB",
    rx: 3.801
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C0E0FD",
    d: "M.454 12.006C.454 5.376 5.833 0 12.456 0h171.385c6.628 0 12.002 5.367 12.002 12.006v44.77H.454z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3AC162",
    fillOpacity: 0.5,
    d: "M.375 55.516h195.388v7.602H.375z",
    opacity: 0.9
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F2C981",
    d: "M37.342 81.551h21.966v-29.39H37.342z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EEBC6E",
    d: "M37.342 81.551h11.005v-29.39H37.342z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9E4C0",
    d: "M36.956 81.551h22.375v-7.897H36.956z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2C981",
    d: "M38.954 79.66h17.784v-4.489H38.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2C981",
    d: "M55.39 79.66h2.667v-4.489H55.39zM36.528 53.18h22.82v-1.019h-22.82z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7D781",
    d: "M36.528 53.18h22.82v-1.02h-22.82z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2C981",
    d: "M83.608 81.551h21.965v-29.39H83.608z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EEBC6E",
    d: "M83.608 81.551h11.005v-29.39H83.608z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9E4C0",
    d: "M83.223 81.551h22.375v-7.897H83.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2C981",
    d: "M85.22 79.66h18.077v-4.489H85.22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2C981",
    d: "M101.656 79.66h2.667v-4.489h-2.667zM82.794 53.18h22.82v-1.019h-22.82z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7D781",
    d: "M82.794 53.18h22.82v-1.02h-22.82z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBEBC0",
    d: "M38.97 65.575h2.666v-4.49H38.97zm4.108 6.234h2.667v-4.49h-2.667zm12.327-6.234h2.667v-4.49h-2.667zm-12.327-5.813h2.667v-4.49h-2.667zm41.938 12.047h2.667v-4.49h-2.667zm12.328 0h2.667v-4.49h-2.667zM85.016 59.762h2.667v-4.49h-2.667zm12.328 0h2.667v-4.49h-2.667z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2C981",
    d: "M57.35 81.548H85.6V39.346H57.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7D781",
    d: "M57.349 81.549h28.25V39.347H57.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAE181",
    d: "M71.422 65.831h14.124V39.347H71.422z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBEBC0",
    d: "M57.349 81.549h28.25V65.83H57.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FDF0C0",
    d: "M71.492 81.485h14.129V65.847H71.492z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBEBC0",
    d: "M59.872 63.845h2.366v-3.819h-2.366zm0-11.81h2.366v-3.82h-2.366z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2C981",
    d: "M78.55 39.257H64.398c0-3.924 3.168-7.105 7.076-7.105s7.076 3.18 7.076 7.105"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7D781",
    d: "M78.507 39.236H71.5l-.068-7.106c3.909 0 7.076 3.181 7.076 7.106"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBEBC0",
    d: "M76.049 38.665h-9.15c0-2.538 2.048-4.595 4.575-4.595 2.526 0 4.575 2.057 4.575 4.595m-.549 25.18h2.366v-3.819H75.5zm5.209-5.858h2.366v-3.82H80.71zm0-11.81h2.366v-3.82H80.71z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2C981",
    d: "M56.675 39.346h29.6v-.648h-29.6zM71.347 69.73c-1.667 0-3.019 1.246-3.019 2.783v9.039h6.038v-9.04c0-1.536-1.352-2.781-3.02-2.781"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424E5B",
    d: "M73.653 72.915H69.04a2.31 2.31 0 0 1 2.306-2.316 2.31 2.31 0 0 1 2.307 2.316m-4.614 8.637h4.568V73.74h-4.568z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2C981",
    d: "M79.516 69.73c-1.667 0-3.019 1.246-3.019 2.783v9.039h6.037v-9.04c0-1.536-1.351-2.781-3.018-2.781"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424E5B",
    d: "M81.822 72.915h-4.613a2.31 2.31 0 0 1 2.306-2.316 2.31 2.31 0 0 1 2.307 2.316m-4.615 8.637h4.568V73.74h-4.568z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2C981",
    d: "M63.3 69.73c-1.668 0-3.019 1.246-3.019 2.783v9.039h6.037v-9.04c0-1.536-1.352-2.781-3.019-2.781"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424E5B",
    d: "M65.605 72.915h-4.613a2.31 2.31 0 0 1 2.307-2.316 2.31 2.31 0 0 1 2.306 2.316m-4.615 8.637h4.569V73.74H60.99z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#F2C981",
    strokeWidth: 0.286,
    d: "M71.34 73.654v7.895m-8.04-7.895v7.895m16.216-7.895v7.895"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.542 25.929)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 29.983)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.752,
    height: 44.769,
    x: 0.103,
    y: 0.103,
    fill: "#14CCE6",
    rx: 6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M35.261 9.91H24.28v6.035h2.305v13.402h-8.656V15.945h2.306V9.91H9.252v6.036h2.69v15.466l4.481 4.518H28.09l4.481-4.518V15.945h2.69z"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 195.388,
    height: 190.618,
    x: 219.622,
    y: 0.262,
    fill: "#FFF",
    rx: 12
  }), /*#__PURE__*/React.createElement("rect", {
    width: 144.027,
    height: 7.602,
    x: 245.66,
    y: 95.175,
    fill: "#DBE4EB",
    rx: 3.801
  }), /*#__PURE__*/React.createElement("rect", {
    width: 89.873,
    height: 7.602,
    x: 245.66,
    y: 111.037,
    fill: "#DBE4EB",
    rx: 3.801
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C0E0FD",
    d: "M219.622 12.006C219.622 5.376 225 0 231.623 0h171.385c6.629 0 12.002 5.367 12.002 12.006v44.77H219.622z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3AC162",
    fillOpacity: 0.5,
    d: "M219.167 56.218h195.846v7.599H219.167z",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(245.66 29.346)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55.239,
    height: 48.705,
    fill: "#72BEFF",
    rx: 6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M43.617 10.43H30.285v6.753h2.798v14.991H22.576V17.183h2.798V10.43H12.042v6.752h3.266v17.3l5.44 5.054h14.163l5.44-5.054v-17.3h3.266z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F3F2",
    d: "m323.53 54.813-3.209 6.924v19.947h69.256l.1-19.828v-.12l-3.193-6.923z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(320.321 54.522)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "college-search-welcome-modal-image-1_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#college-search-welcome-modal-image-1_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DBE4EC",
    d: "M8.969 27.162h-8.97V7.215L3.21.29h5.76z",
    mask: "url(#college-search-welcome-modal-image-1_svg__b)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(320.321 54.522)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "college-search-welcome-modal-image-1_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#college-search-welcome-modal-image-1_svg__c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DBE4EC",
    d: "M69.255 27.162H0V7.215L3.209.29h66.046z",
    mask: "url(#college-search-welcome-modal-image-1_svg__d)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F3F2",
    d: "M329.29 81.684h51.399v-35.86h-51.4z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(320.321 32.487)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DBE4EC",
    d: "M8.968 48.965h51.4V13.107h-51.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#939FAA",
    d: "M41.615 47.828H27.498V38.84c0-2.903 2.37-5.277 5.268-5.277h3.58c2.898 0 5.269 2.374 5.269 5.277z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424E5B",
    d: "M40.434 47.828H28.679v-8.833c0-2.475 2.022-4.5 4.494-4.5h2.767c2.471 0 4.494 2.025 4.494 4.5zm19.923-34.723h-51.4L12.15 6.18h45.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2A353F",
    d: "M33.476 13.105H8.956l3.195-6.924h18.128zM9.013 29.018h-9l3.196-6.924h5.804z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(59.865 21.803)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "college-search-welcome-modal-image-1_svg__f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#college-search-welcome-modal-image-1_svg__e"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#424E5B",
    d: "M.492 7.215h9L6.297.29H.492z",
    mask: "url(#college-search-welcome-modal-image-1_svg__f)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#939FAA",
    d: "M19.681 24.345h-6.49v-4.83c0-1.789 1.46-3.25 3.245-3.25a3.257 3.257 0 0 1 3.245 3.25zm10.05 0h-6.49v-4.83c0-1.789 1.46-3.25 3.244-3.25a3.257 3.257 0 0 1 3.246 3.25zm17.359 0h-6.491v-4.83c0-1.789 1.46-3.25 3.245-3.25a3.257 3.257 0 0 1 3.246 3.25zm10.05 0h-6.491v-4.83c0-1.789 1.46-3.25 3.244-3.25a3.257 3.257 0 0 1 3.246 3.25z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "college-search-welcome-modal-image-1_svg__h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#college-search-welcome-modal-image-1_svg__g"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#939FAA",
    d: "M27.584 48.737h14.088v-1.479H27.584z",
    mask: "url(#college-search-welcome-modal-image-1_svg__h)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#939FAA",
    d: "M0 49.058h69.255v-1.8H0z",
    mask: "url(#college-search-welcome-modal-image-1_svg__h)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M21.127 48.357h2.682V33.015h-2.682zm-9.947 0h2.682V33.015h-2.681zm43.868 0h2.682V33.015h-2.682zm-9.947 0h2.682V33.015h-2.682zm15.266-15.342v-2.318H39.1l-4.424-5.232-4.424 5.232H8.968v2.318",
    mask: "url(#college-search-welcome-modal-image-1_svg__h)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F3F2",
    d: "M43.868 13.53h1.784V9.038h-1.784zm11.034-4.493h-1.784v1.83l1.784 2.11z",
    mask: "url(#college-search-welcome-modal-image-1_svg__h)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m44.76 6.966-.892 2.072h1.784zm9.25 0-.892 2.072h1.784zm-4.62-.506-6.406 7.577h12.813z",
    mask: "url(#college-search-welcome-modal-image-1_svg__h)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m49.39 6.46-6.406 7.577h12.813z",
    mask: "url(#college-search-welcome-modal-image-1_svg__h)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#939FAA",
    d: "M47.446 12.196c0-1.07.875-1.948 1.945-1.948s1.945.877 1.945 1.948z",
    mask: "url(#college-search-welcome-modal-image-1_svg__h)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m16.287 6.966-.891 2.072h1.783zm9.25 0-.892 2.072h1.784zm-4.619-.506-6.407 7.577h12.814z",
    mask: "url(#college-search-welcome-modal-image-1_svg__h)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m20.918 6.46-6.407 7.577h12.814z",
    mask: "url(#college-search-welcome-modal-image-1_svg__h)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2D7C0",
    d: "m20.918 6.46-6.407 7.577",
    mask: "url(#college-search-welcome-modal-image-1_svg__h)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#939FAA",
    d: "M18.973 12.196c0-1.07.875-1.948 1.945-1.948s1.945.877 1.945 1.948z",
    mask: "url(#college-search-welcome-modal-image-1_svg__h)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M15.396 13.53h1.783V9.038h-1.783zm9.249 0h1.784V9.038h-1.784z",
    mask: "url(#college-search-welcome-modal-image-1_svg__h)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m24.059 13.107-.9 1.065h23.03l-.87-1.027zM34.673.554 24.06 13.107l21.26.037z",
    mask: "url(#college-search-welcome-modal-image-1_svg__h)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#939FAA",
    d: "M31.825 9.428a2.86 2.86 0 0 1 2.849-2.853 2.86 2.86 0 0 1 2.848 2.853z",
    mask: "url(#college-search-welcome-modal-image-1_svg__h)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F3F2",
    d: "M8.976 14.944h51.382v-1.81H8.976zm19.438 23.817h12.2v-.645h-12.2z",
    mask: "url(#college-search-welcome-modal-image-1_svg__h)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#939FAA",
    d: "M28.414 38.761h12.2v-.645h-12.2z",
    mask: "url(#college-search-welcome-modal-image-1_svg__h)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#939FAA",
    d: "M28.414 38.761h6.264v-.645h-6.264zm6.261-13.283-.017-1.297-5.435 6.451h1.11z",
    mask: "url(#college-search-welcome-modal-image-1_svg__h)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#939FAA",
    d: "m34.61 25.478.048-1.297 5.405 6.451h-1.08z",
    mask: "url(#college-search-welcome-modal-image-1_svg__h)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#939FA9",
    d: "m45.05 14.287 1.29.002L34.64.45 22.973 14.249l1.288.003 10.38-12.275z",
    mask: "url(#college-search-welcome-modal-image-1_svg__h)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#939FAA",
    d: "M34.318 47.258h.707v-8.497h-.707z",
    mask: "url(#college-search-welcome-modal-image-1_svg__h)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(103.964 10)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#college-search-welcome-modal-image-1_svg__j",
    fill: "#000",
    filter: "url(#college-search-welcome-modal-image-1_svg__i)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#college-search-welcome-modal-image-1_svg__j",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 168.031,
    height: 8.869,
    x: 30.908,
    y: 111.037,
    fill: "#DBE4EB",
    rx: 4.435
  }), /*#__PURE__*/React.createElement("rect", {
    width: 104.852,
    height: 8.869,
    x: 30.908,
    y: 129.544,
    fill: "#DBE4EB",
    rx: 4.435
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C0E0FD",
    d: "M.53 11.995C.53 5.37 5.912 0 12.525 0h203.964c6.624 0 11.994 5.364 11.994 11.995v54.243H.53z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(49.41 2.878)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M64.88 0c8.388 0 15.616 4.822 18.92 11.772H45.962C49.266 4.822 56.494 0 64.88 0"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "college-search-welcome-modal-image-1_svg__l",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#college-search-welcome-modal-image-1_svg__k"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E54F00",
    d: "M0 61.15h129.859V25.116H0z",
    mask: "url(#college-search-welcome-modal-image-1_svg__l)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E54F00",
    d: "M0 61.15h64.93V25.116H0z",
    mask: "url(#college-search-welcome-modal-image-1_svg__l)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE6A00",
    d: "M43.663 14.576h42.404v-2.983H43.663z",
    mask: "url(#college-search-welcome-modal-image-1_svg__l)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E54F00",
    d: "M43.663 14.576h21.315v-2.983H43.663z",
    mask: "url(#college-search-welcome-modal-image-1_svg__l)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE6A00",
    d: "M51.141 25.342h3.431v-1.3h-3.43zM49.6 26.877h3.432v-1.3H49.6z",
    mask: "url(#college-search-welcome-modal-image-1_svg__l)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9F4ED",
    d: "M72.96 38.115c-.037-3.104-3.699-5.613-8.213-5.613s-8.176 2.51-8.212 5.613h-.003v1.212h16.429v-1.212z",
    mask: "url(#college-search-welcome-modal-image-1_svg__l)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9DCCD",
    d: "M70.717 37.173c-.027-1.846-2.668-3.338-5.925-3.338s-5.898 1.492-5.924 3.338h-.002v.722h11.852v-.722z",
    mask: "url(#college-search-welcome-modal-image-1_svg__l)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9F4ED",
    d: "M70.718 56.743h2.238V38.861h-2.238z",
    mask: "url(#college-search-welcome-modal-image-1_svg__l)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424E5B",
    d: "M58.704 56.612H70.79V39.327H58.704z",
    mask: "url(#college-search-welcome-modal-image-1_svg__l)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9F4ED",
    d: "M56.532 56.888h2.238V39.005h-2.238z",
    mask: "url(#college-search-welcome-modal-image-1_svg__l)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9DCCD",
    d: "M105.958 52.944h5.52V28.516h-5.52zm13.316 0h5.52V28.516h-5.52zm-100.964 0h5.52V28.516h-5.52zm-13.09 0h5.52V28.516H5.22zM0 62.053h129.859V55.82H0z",
    mask: "url(#college-search-welcome-modal-image-1_svg__l)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9F4ED",
    d: "M48.866 56.888h3.099v-28.46h-3.099zm28.586-.726h3.098V28.428h-3.098zm-40.616.603h3.1V28.428h-3.1zm53.054-.707h3.099v-27.63H89.89z",
    mask: "url(#college-search-welcome-modal-image-1_svg__l)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#939FA9",
    d: "M109.484 14.576H64.927v10.54h64.932z",
    mask: "url(#college-search-welcome-modal-image-1_svg__l)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424E5B",
    d: "M20.375 14.576H64.93v10.54H0z",
    mask: "url(#college-search-welcome-modal-image-1_svg__l)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9DCCD",
    d: "M36.866 28.428H93.02v-3.473H36.866z",
    mask: "url(#college-search-welcome-modal-image-1_svg__l)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9F4ED",
    d: "m64.927 14.576-28.09 10.38h56.182z",
    mask: "url(#college-search-welcome-modal-image-1_svg__l)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9DCCD",
    d: "M53.36 11.055h-3.192V8.593c0-.587.489-1.063 1.093-1.063h1.007c.604 0 1.092.476 1.092 1.063zm8.196 0h-3.192V8.593c0-.587.489-1.063 1.093-1.063h1.007c.604 0 1.092.476 1.092 1.063zm9.892 0h-3.193V8.593c0-.587.49-1.063 1.093-1.063h1.008c.603 0 1.092.476 1.092 1.063zm7.595 0h-3.192V8.593c0-.587.49-1.063 1.092-1.063h1.008c.603 0 1.092.476 1.092 1.063z",
    mask: "url(#college-search-welcome-modal-image-1_svg__l)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#3AC162",
    d: "M0 64.772h228.483v8.869H0z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.908 31.426)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63.69,
    height: 63.714,
    fill: "#2D95F3",
    rx: 6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M50.886 14.043H35.332v8.549h3.265v18.98H26.338v-18.98h3.265v-8.549H14.05v8.549h3.81v21.903l6.347 6.4H40.73l6.347-6.4V22.592h3.81z"
  }))))));
};
export default SvgCollegeSearchWelcomeModalImage1;